import React, { useCallback, useState, useRef, useEffect } from "react";
import { useDropzone } from "react-dropzone";
import { useClipboard } from "@chakra-ui/react";
import {
  Box,
  Text,
  Flex,
  Image,
  useToast,
  Button,
  Icon,
} from "@chakra-ui/react";
import { ReactSVG } from "react-svg";
import { RiUpload2Line, RiImageEditFill } from "@remixicon/react";
import { useAppDispatch, useAppSelector } from "@/store/hooks";
import { imageUploaded } from "@/services/api/thunks/image";
import { selectUser } from "@/reducer/userslice";
import smrImage4 from "@/assets/images/smr_img4.png";

type Props = {
  upDateImages: (files: File[]) => void;
};
const SmrImageUploader = (props: Props) => {
  const dispatch = useAppDispatch();
  const toast = useToast();
  const [files, setFiles] = useState<File[]>([]);
  const fileRef = useRef<HTMLInputElement>(null);
  const user = useAppSelector(selectUser);
  // const { onPaste, data } = useClipboard();
  const maxSize = 5 * 1024 * 1024; // 2MB

  const handleDrop = useCallback(
    (acceptedFiles: File[]) => {
      // 处理接收到的文件，例如上传到服务器
      if (files.length + acceptedFiles.length > 1) {
        toast({
          title: "图片数量超过1张，上传失败。",
          position: "top",
          status: "error",
        });
      } else if (acceptedFiles.length > 0) {
        const newFile =
          files.length > 0 ? [...files, ...acceptedFiles] : [...acceptedFiles];
        console.log(newFile, "123");
        setFiles(newFile);

        props.upDateImages(newFile as File[]);
        // toast({ title: "图片已上传。", position: "top", status: "success" });
      }
    },
    [toast, files]
  );

  const { getRootProps, getInputProps, open } = useDropzone({
    accept: {
      "image/*": [".jpeg", ".png"],
    },
    maxFiles: 1,
    maxSize: maxSize,
    onDrop: handleDrop,
    noClick: true,
    multiple: false,
    onDropRejected: () => {
      toast({
        title: "上传的文件类型(仅支持png、jpeg)或数量不符合要求！",
        position: "top",
        status: "error",
      });
    },
  });

  const handlePaste = (event: ClipboardEvent) => {
    event.preventDefault();
    event.stopPropagation();
    const items = event.clipboardData?.items;
    if (!items) return;
    const imageFile = Array.from(items).find(
      (item) => item.kind === "file" && item.type.startsWith("image/")
    );
    if (!imageFile) {
      toast({ title: "请粘贴图片格式。", position: "top", status: "error" });
      return;
    }
    const imageFilelist = [imageFile.getAsFile()].filter(Boolean) as File[];

    if (files.length + imageFilelist.length > 3) {
      toast({
        title: "图片数量已达上限。",
        position: "top",
        status: "error",
      });
    }
    if (imageFilelist.length > 0) {
      const newFile =
        files.length > 0 ? [...files, ...imageFilelist] : [...imageFilelist];
      console.log(newFile, "123");
      setFiles(newFile);
      toast({ title: "图片已粘贴。", position: "top", status: "success" });
    }
  };

  // useEffect(() => {
  //   document.addEventListener("paste", handlePaste);
  //   return () => {
  //     document.removeEventListener("paste", handlePaste);
  //   };
  // }, []);

  const handleClickPaste = async () => {
    const items = await navigator.clipboard.read();
    console.log(items);
    items.forEach(async (clipboardItem) => {
      for (const type of clipboardItem.types) {
        if (type === "image/png" || type === "image/jpeg") {
          const blob = await clipboardItem.getType(type);
          const url = URL.createObjectURL(blob);
          console.log("Pasted image URL:", url);
          // 这里可以处理你的图片文件，比如展示、上传等操作

          if (files.length < 3) {
            const newFile = files.length > 0 ? [...files, url] : [url];
            console.log(newFile, "123");
            // setFiles(newFile);
            // toast({ title: "图片已粘贴。", position: "top", status: "success" });
          } else {
            toast({
              title: "图片数量已达上限。",
              position: "top",
              status: "error",
            });
          }
        }
      }
    });
  };

  const handleOpen = () => {
    if (user && user.id) {
      open();
    } else {
      toast({
        title: "请登录系统",
        position: "top",
        status: "error",
        duration: 1000,
      });
    }
  };

  return (
    <Flex
      {...getRootProps()}
      h="200px"
      justifyContent="center"
      bg={"#0C0B10"}
      borderRadius="10px"
    >
      <input {...getInputProps()} />
      <Flex
        w="100%"
        h="100%"
        flexDirection={"column"}
        justifyContent="center"
        gap="10px"
        alignItems="center"
        onClick={handleOpen}
        
      >
        <Image src={smrImage4} />
        <Text
          fontSize={"14px"}
          sx={{
            bgGradient: "linear-gradient(90deg, #66E8E0 0%, #496AE1 100%)",
            backgroundClip: "text",
            webkitBackgroundClip: "text",
          }}
        >
          点击 / 拖拽
        </Text>
      </Flex>
    </Flex>
  );
};

export default SmrImageUploader;
